import React, { useState } from "react";
import Layout from "../form-layout";
import { LAST_DOSE_GAP } from "../../data/eligibility-rules";

// Q16 — "When did you administer your most recent dose?" This is the safety-relevant
// gap question: >28 days triggers a forced dose reset flag (see computeFinalTier),
// which is the objective boundary for when a "current" GLP-1 user needs to be treated
// like they're restarting rather than continuing.
export default function Step16({ formData, setFormData, onBack, goToStep }) {
  const [gap, setGap] = useState(formData.lastDoseGap || "");
  const [gapDetail, setGapDetail] = useState(formData.lastDoseGapDetail || "");

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!gap) return;
    if ((gap === "d15to28" || gap === "gt28") && !gapDetail.trim()) return;

    setFormData((prev) => ({ ...prev, lastDoseGap: gap, lastDoseGapDetail: gapDetail }));
    localStorage.setItem("lastDoseGap", gap);
    localStorage.setItem("lastDoseGapDetail", gapDetail);

    goToStep("17");
  };

  const needsDetail = gap === "d15to28" || gap === "gt28";

  return (
    <Layout goToStep={goToStep} onBack={onBack}>
      <h2 className="text-sm sm:text-[14px] font-medium text-[#000000] mb-6">
        When did you administer your most recent dose?
      </h2>

      <form onSubmit={handleSubmit} className="flex flex-col gap-3">
        {LAST_DOSE_GAP.map((option) => (
          <label key={option.key} className="flex items-center gap-2 p-3 rounded-lg cursor-pointer border transition-all text-sm">
            <input
              type="radio"
              name="lastDoseGap"
              checked={gap === option.key}
              onChange={() => setGap(option.key)}
              className="h-4 w-4 accent-sky-400 cursor-pointer"
            />
            <span>{option.label}</span>
          </label>
        ))}

        {needsDetail && (
          <input
            type="text"
            value={gapDetail}
            onChange={(e) => setGapDetail(e.target.value)}
            placeholder='Approximately how many weeks or months? e.g. "6 weeks" or "approx 3 months"'
            className="border-2 border-sky-300 rounded-xl p-3 focus:outline-none focus:ring-2 focus:ring-[#35C3D9]"
          />
        )}

        <div className="flex justify-start mt-2">
          <button
            type="submit"
            disabled={!gap || (needsDetail && !gapDetail.trim())}
            className={`w-[210px] text-sm font-semibold rounded-lg py-3 transition-colors
              ${
                !gap || (needsDetail && !gapDetail.trim())
                  ? "bg-gray-300 text-gray-600 cursor-not-allowed"
                  : "bg-[#35C3D9] text-white hover:bg-[#27AAC0]"
              }`}
          >
            Next →
          </button>
        </div>
      </form>
    </Layout>
  );
}
